import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  useCreateOwnershipDraftFetchMutation,
  useCreateauthorizedsignDraftFetchMutation,
  useKeypersonneldetailsdraftFetchMutation,
  useRelatedEntityDraftFetchMutation,
  useBusinessRelationDraftFetchMutation,
  useBankdetailsdraftFetchMutation,
  useCreateInsuranceDraftFetchMutation,
  useFetchCompanyDraftEditMutation,
} from "../../../../store/Company/companyApiSlice";

/* The pending drafts the rail's completion dots need — F-100. */

/* `res.data.data` for the six list sections; ownership answers with
   { ownership_ind, ownership_com } at `res.data` instead, which
   mergeOwnershipDrafts takes whole. */
const rowsOf = (res) => res?.data?.data || [];

export const useCompletionDrafts = (companyID) => {
  const { token } = useSelector((state) => state.auth);

  const [fetchOwnership] = useCreateOwnershipDraftFetchMutation();
  const [fetchSignatory] = useCreateauthorizedsignDraftFetchMutation();
  const [fetchPersonnel] = useKeypersonneldetailsdraftFetchMutation();
  const [fetchEntity] = useRelatedEntityDraftFetchMutation();
  const [fetchBusiness] = useBusinessRelationDraftFetchMutation();
  const [fetchBank] = useBankdetailsdraftFetchMutation();
  const [fetchInsurance] = useCreateInsuranceDraftFetchMutation();
  const [fetchCompanyDraft] = useFetchCompanyDraftEditMutation();

  const [extras, setExtras] = useState({});

  /* Exposed so the page can re-read after a save: approving or deleting a row
     moves a dot, and the rail must not keep the pre-save answer. */
  const refresh = useCallback(async () => {
    if (!companyID || !token) return;
    const args = { companyID, token };

    /* One settled batch: a section whose endpoint fails must not take the
       other six down with it. */
    const [own, sig, per, ent, biz, bank, ins, comp] = await Promise.allSettled([
      fetchOwnership(args),
      fetchSignatory(args),
      fetchPersonnel(args),
      fetchEntity(args),
      fetchBusiness(args),
      fetchBank(args),
      fetchInsurance(args),
      /* This one takes `companyId`, not `companyID`. */
      fetchCompanyDraft({ companyId: companyID, token }),
    ]);

    const ok = (settled) => (settled.status === "fulfilled" ? settled.value : undefined);

    setExtras({
      ownershipDrafts: ok(own)?.data,
      /* The endpoint answers with a LIST holding at most one row. */
      companyDraft: ok(comp)?.data?.[0],
      drafts: {
        signatory: rowsOf(ok(sig)),
        personnel: rowsOf(ok(per)),
        entity: rowsOf(ok(ent)),
        business: rowsOf(ok(biz)),
        bank: rowsOf(ok(bank)),
        insurance: rowsOf(ok(ins)),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyID, token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { extras, refresh };
};

export default useCompletionDrafts;
